<template>
  <v-container max-width="720">
    <!-- Header -->
    <v-card class="pa-8 mb-4 text-center" color="grey-darken-3" rounded="xl" elevation="0">
      <v-avatar size="80" class="mb-4" style="border: 3px solid rgba(255,255,255,0.3);">
        <v-img src="/uploads/logo.jpg" cover />
      </v-avatar>
      <h1 class="text-h5 font-weight-bold text-white mb-1">Sunrise Events</h1>
      <p class="text-body-2 text-white" style="opacity: 0.75;">Event Management System</p>
    </v-card>

    <!-- Description -->
    <v-card variant="outlined" class="pa-6 mb-4" rounded="xl">
      <p class="text-body-1 text-medium-emphasis">
        A modern event management platform built with Vue 3, Vuetify, Node.js, and MySQL.
        It allows event organisers to create events, manage attendees, send PDF invitations,
        and monitor live check-ins — all from a single desktop application.
      </p>
    </v-card>

    <!-- Feature chips -->
    <div class="text-subtitle-2 font-weight-medium mb-3">Features</div>
    <v-row class="mb-4">
      <v-col v-for="feat in features" :key="feat.label" cols="12" sm="6">
        <v-card variant="tonal" :color="feat.color" class="pa-4 d-flex align-center" rounded="lg" style="gap:12px;">
          <v-icon :color="feat.color" size="28">{{ feat.icon }}</v-icon>
          <div>
            <div class="text-subtitle-2 font-weight-bold">{{ feat.label }}</div>
            <div class="text-caption text-medium-emphasis">{{ feat.desc }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Footer -->
    <div class="text-center text-caption text-medium-emphasis">
      &copy; {{ new Date().getFullYear() }} Sunrise Events &mdash; Built by <strong>Bachir Souldi</strong>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      features: [
        { icon: "mdi-calendar-multiple",         color: "blue",   label: "Event Management",    desc: "Create, edit, and track events" },
        { icon: "mdi-account-group",             color: "teal",   label: "Attendee Tracking",   desc: "Manage and bulk-import attendees" },
        { icon: "mdi-qrcode-scan",               color: "orange", label: "QR Check-In",         desc: "Instant camera or USB scanner check-in" },
        { icon: "mdi-file-pdf-box",              color: "red",    label: "PDF Invitations",     desc: "Auto-generated with embedded QR code" },
        { icon: "mdi-email-fast-outline",        color: "purple", label: "Email Delivery",      desc: "Send invitations directly by email" },
        { icon: "mdi-chart-bar",                 color: "green",  label: "Live Dashboard",      desc: "Real-time stats and gender analytics" },
      ],
    };
  },
};
</script>
